<div class="kt-grid kt-grid--ver kt-grid--root kt-page" style="min-height: 100vh;">
    <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v1" id="kt_login">
        <div
            class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">

            <!--begin::Aside-->
            <div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
                style="background-color: #005BAA;">
                <div class="kt-grid__item">

                    <div class="kt-login__info">
                        <a routerLink="/login" class="kt-login__logo">
                            <img src="assets/img/bkd_siyah_zeminsiz.png" width="160" height="53" style="margin-right: 30px;">
                            <img src="assets/img/boost-logo.png" width="180" height="70">
                        </a>
                        <!-- <div class="kt-login__menu">
                            <a href="https://www.bilimkahramanlari.org/iletisim/" target="_blank" class="kt-link">İletişim</a>
                            <a href="https://fonzip.com/bilimkahramanlari/bagis#/" target="_blank" class="kt-link">Bağış</a>
                            <a routerLink="/kvkk" class="kt-link">KVKK</a>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto1.jpg" style="width: 33%;">
                        <img src="assets/img/foto2.jpg" style="width: 33%;">
                        <img src="assets/img/foto3.JPG" style="width: 33%;">
                    </div>
                </div> -->
                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                    <div class="kt-grid__item kt-grid__item--fluid" style="margin-top: 25px;">
                        <h3 class="kt-login__title" style="text-align: center;">Bilim Kahramanları Derneği <br> Gönüllü Portalı'na<br> Hoş Geldin!</h3>
                        <!-- <h4 class="kt-login__subtitle" style="color: #000;">Bilim Kahramanları Derneği Gönüllü Portalı'na Hoş Geldin!</h4> -->
                    </div>
                </div>
                <div class="kt-grid__item" style="margin-top: 5px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto1.jpg" style="width: 50%;">
                        <img src="assets/img/foto2.jpg" style="width: 50%;">
                    </div>
                </div>
                 <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto4.jpg" style="width: 100%;">
                    </div>
                </div>
                
            </div>

            <!--begin::Aside-->

            <!--begin::Content-->
            <div
                class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">

                <!--begin::Head-->
                <div class="kt-login__head">
                    <span class="kt-login__signup-label">Hesabın yok mu?</span>&nbsp;&nbsp;
                    <a routerLink="/register" class="kt-link kt-login__signup-link">Hesap oluştur!</a>
                </div>

                <!--end::Head-->

                <!--begin::Body-->
                <div class="kt-login__body">

                    <!--begin::Signin-->
                    <div class="kt-login__form">
                        <div class="kt-login__title">
                            <h3>Giriş Yap</h3>
                        </div>

                        <!--begin::Form-->
                        <form class="kt-form" [formGroup]="loginForm" (ngSubmit)="login()" id="kt_login_form">
                            <div class="form-group">
                                <input formControlName="email" class="form-control" type="text" placeholder="Email"
                                    name="username" autocomplete="off">
                                <small class="form-text text-warning" *ngIf="f.email.errors?.required">Lütfen emailinizi
                                    giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.email.errors?.pattern">Lütfen geçerli bir
                                    email giriniz!</small>
                            </div>
                            <div class="form-group">
                                <input formControlName="password" class="form-control" type="password"
                                    placeholder="Şifre" name="password" autocomplete="off">
                                <small class="form-text text-warning" *ngIf="f.password.errors?.required">Lütfen
                                    şifrenizi giriniz!</small>
                            </div>

                            <!--begin::Action-->
                            <div class="kt-login__actions">
                                <a routerLink="/forget-password" class="kt-link kt-login__link-forgot">
                                    Şifreni mi unuttun?
                                </a>
                                <button id="kt_login_signin_submit"
                                    class="btn btn-primary btn-elevate kt-login__btn-primary">Giriş Yap</button>
                            </div>

                            <!--end::Action-->
                        </form>

                        <!--end::Form-->

                        <!--begin::Divider-->
                        <div class="kt-login__divider">
                            <!-- <div class="kt-divider">
                                <span></span>
                                <span>|</span>
                                <span></span>
                            </div> -->
                            <!-- <div class="kt-divider">
                                <span></span>
                                <span>Sosyal medya hesaplarımız</span>
                                <span></span>
                            </div> -->
                        </div>

                        <!--end::Divider-->

                        <!--begin::Options-->
                        <div class="kt-login__options">
                            <a href="https://bilimkahramanlari.org" target="_blank"
                                class="btn btn-primary kt-btn" style="margin-right: 10px;">
                                <i class="fa fa-info-circle"></i>
                                Dernek Hakkında
                            </a>
                            <a routerLink="/about-project" target="_blank"
                                class="btn btn-dark kt-btn">
                                <i class="fa fa-search"></i>
                                Gönüllü Portalı Hakkında
                            </a>

                        </div>
                        <!-- <div class="kt-login__options" style="margin-top: 10px;">
                            <a href="https://www.youtube.com/user/bilimkahramanlari" target="_blank"
                                class="btn btn-danger kt-btn">
                                <i class="fab fa-youtube"></i>
                                YouTube
                            </a>
                            <a href="https://www.linkedin.com/company/bilim-kahramanlar%C4%B1-derne%C4%9Fi"
                                target="_blank" class="btn btn-primary kt-btn">
                                <i class="fab fa-linkedin"></i>
                                LinkedIn
                            </a>
                            <a href="https://www.bilimkahramanlari.org" target="_blank" class="btn btn-dark kt-btn">
                                <i class="fa fa-heart"></i>
                                Website
                            </a>
                        </div> -->
                        <!-- <div class="kt-login__account" style="margin-top: 10px;text-align: center;">
                            <span class="kt-login__account-msg">
                                Proje hakkında bilgi almak için lütfen 
                            </span>
                            <a routerLink="/about-project" target="_blank" id="kt_login_signup" class="kt-login__account-link">buraya</a> tıklayın!
                        </div> -->
                        <!--end::Options-->
                    </div>

                    <!--end::Signin-->
                    
                </div>

                

                <!--end::Body-->
            </div>

            <!--end::Content-->
        </div>
    </div>
</div>